// src/components/mf-header-height.ts
class MfHeaderHeight {
  private static ro: ResizeObserver | null = null;
  private static headerEl: HTMLElement | null = null;
  private static cssVarName = '--header-h';
  private static rootEl: HTMLElement = document.documentElement;
  private static boundApply: (() => void) | null = null;

  /**
   * Startet das Messen und setzt die CSS-Variable.
   * @param opts.selector   CSS-Selector des Headers (default: '.header')
   * @param opts.cssVarName Name der CSS-Variable (default: '--header-h')
   * @param opts.root       Element, an dem die CSS-Variable gesetzt wird (default: <html>)
   */
  static init(opts?: { selector?: string; cssVarName?: string; root?: HTMLElement }): void {
    const selector = opts?.selector ?? '.header';
    this.cssVarName = opts?.cssVarName ?? '--header-h';
    this.rootEl = opts?.root ?? document.documentElement;

    const header = document.querySelector<HTMLElement>(selector);
    this.headerEl = header;
    if (!header) return;

    const apply = () => {
      const h = header.getBoundingClientRect().height;
      this.rootEl.style.setProperty(this.cssVarName, `${h}px`);
    };
    this.boundApply = apply;

    // initial
    apply();

    // ResizeObserver (falls verfügbar)
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(apply);
      this.ro.observe(header);
    }

    // Viewport-/Layout-Änderungen
    window.addEventListener('resize', apply);

    // Fonts können die Höhe ändern
    const anyDoc = document as any;
    if (anyDoc.fonts?.ready) {
      anyDoc.fonts.ready.then(apply).catch(() => {});
    }
  }

  /** Manuell neu berechnen */
  static refresh(): void {
    this.boundApply?.();
  }

  /** Aufräumen (Observer/Listener entfernen) */
  static destroy(): void {
    if (this.ro && this.headerEl) {
      this.ro.unobserve(this.headerEl);
      this.ro.disconnect();
    }
    if (this.boundApply) {
      window.removeEventListener('resize', this.boundApply);
    }
    this.ro = null;
    this.headerEl = null;
    this.boundApply = null;
  }
}

export default MfHeaderHeight;
